var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.93983 8.78109C1.71211 8.28568 1.71211 7.71416 1.93983 7.21875C2.9939 4.92554 5.31122 3.33325 8.00044 3.33325C10.6897 3.33325 13.007 4.92554 14.0611 7.21875C14.2888 7.71416 14.2888 8.28568 14.0611 8.78109C13.007 11.0743 10.6897 12.6666 8.00044 12.6666C5.31122 12.6666 2.9939 11.0743 1.93983 8.78109Z",
    stroke: "#000536",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 7.99992C10.0004 9.10449 9.10501 9.99992 8.00044 9.99992C6.89588 9.99992 6.00044 9.10449 6.00044 7.99992C6.00044 6.89535 6.89588 5.99992 8.00044 5.99992C9.10501 5.99992 10.0004 6.89535 10.0004 7.99992Z",
    stroke: "#000536",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.3a4112e223e04f3749805a581576e374.svg";
export { ForwardRef as ReactComponent };